export enum UserRole {
  SuperAdmin = 'SuperAdmin',
  Admin = 'RiskMapAdmin',
  Manager = 'RiskMapManager',
  Basic = 'RiskMapBasic'
}
